module.exports = __webpack_public_path__ + "files/06a4801d5e2e6575245b91cb52a6ccc7.png";